import { useMemo, useState } from "react";
import { Offcanvas, Spinner } from "react-bootstrap";
import { axiosGetWithHeader } from "../Common/axios";
import { handleClickColor } from "../Common/Util";

export function PositionOffCanvas({showpopup,handlePopup,userData}){
  const [chartData, setChartData] = useState([]);
  const [cuspData, setCuspData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Planetary Position');
  const [position, setPosition] = useState('end');
  const handlePosition = ()=>setPosition(position==='end'?'start':'end');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/planetarypositionchart/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );
    axiosGetWithHeader("/chart/cuspalpositionchart/"+clientId,
      (response)=>{
        setCuspData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setCuspData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

  return (
    <> 
      {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
      <Offcanvas show={showpopup} onHide={handlePopup} placement={position} backdrop={false} style={{opacity: 1.0,"overflow-y": "auto"}}>
        <Offcanvas.Header class="m-0 p-0" closeButton>
          <Offcanvas.Title class="w-100">
            <table class="w-100">
              <tr>
                <td class="text-start"><h5>Natal Position</h5></td>
                <td class="text-end"><button type="button" class="btn btn-outline-primary" onClick={handlePosition}>{position==='end'?'<- Left':'Right ->'}</button></td>
              </tr>
            </table>
            </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body class="m-0 p-0">
        {chartData===null||chartData===undefined||chartData.length===0?<></>:
            <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
            <caption class="m-0 p-0" ><h5 class="m-0 p-1">Planetary Position</h5></caption>
            <thead>
                <tr class="m-0 p-0">
                <th class="m-0 p-0 kptable-td">Planet</th> 
                <th class="m-0 p-0 kptable-td">Sign Lord</th> 
                <th class="m-0 p-0 kptable-td">Star Lord</th> 
                <th class="m-0 p-0 kptable-td">Sub Lord</th> 
                <th class="m-0 p-0 kptable-td">Sub Sub Lord</th> 
                </tr>
            </thead>
            <tbody>
            {chartData.map((planet) => (
                <tr class="m-0 p-0" onClick={handleClickColor}>
                    <th class="bg-transparent text-start m-0 p-0 ps-1">{planet[0]}</th>
                    <td class="bg-transparent text-center m-0 p-0">{planet[6].substring(0,3)}</td>
                    <td class="bg-transparent text-center m-0 p-0">{planet[9].substring(0,3)}</td>
                    <td class="bg-transparent text-center m-0 p-0">{planet[10].substring(0,3)}</td>
                    <td class="bg-transparent text-center m-0 p-0">{planet[11].substring(0,3)}</td>
                </tr>
            ))}
            </tbody>                    
            </table>
        }

        {cuspData===null||cuspData===undefined||chartData.length===0?<></>:
            <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
            <caption class="m-0 p-0" ><h5 class="m-0 p-1">House Position</h5></caption>
            <thead>
                <tr class="m-0 p-0">
                <th class="m-0 p-0 kptable-td">Planet</th> 
                <th class="m-0 p-0 kptable-td">Sign Lord</th> 
                <th class="m-0 p-0 kptable-td">Star Lord</th> 
                <th class="m-0 p-0 kptable-td">Sub Lord</th> 
                <th class="m-0 p-0 kptable-td">Sub Sub Lord</th> 
                </tr>
            </thead>
            <tbody>
            {cuspData.map((planet) => (
                <tr class="m-0 p-0" onClick={handleClickColor}>
                    <th class="bg-transparent text-start m-0 p-0 ps-1">{planet[0]}</th>
                    <td class="bg-transparent text-center m-0 p-0">{planet[6].substring(0,3)}</td>
                    <td class="bg-transparent text-center m-0 p-0">{planet[9].substring(0,3)}</td>
                    <td class="bg-transparent text-center m-0 p-0">{planet[10].substring(0,3)}</td>
                    <td class="bg-transparent text-center m-0 p-0">{planet[11].substring(0,3)}</td>
                </tr>
            ))}
            </tbody>                    
            </table>
        }

        </Offcanvas.Body>
      </Offcanvas>        
    </>
  );
}